import styled, { css } from "styled-components";
import { colours } from "assets/colours";
import { fonts } from "assets/fontStyles";

const StyledBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${fonts.badge}
  min-width: 10.9375em;
  padding: 0.5em 1em;
  border-radius: 3.4375em;
  border: none;
  background: ${colours.primary};
  color: ${colours.white};


  ${({ variant }) =>
    variant &&
    css`
      /** 26 is hex code for opacity 0.15 */
      background: ${colours[variant]};
      color: 'white';
    `}
`;

export { StyledBadge };
